// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3MvxD","header":"ReportDetails_header__3H3C7","title":"ReportDetails_title__21ezZ","left":"ReportDetails_left__13_4w"};